// extracted by mini-css-extract-plugin
export default {"map_container":"mapPopup_map_container__tdSGK","btn_container":"mapPopup_btn_container__mE2uU"};